import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { ProgressSpinner } from "primereact/progressspinner";
import ImageCanvas from "./ImageCanvas";
import { useEffect, useRef, useState } from "react";
import MarkingControlButton from "./MarkingControlButton";
import MarkingProblemTable from "../foto/MarkingProblemTable";
import { getMarkingReferenceImage } from "../../utils/getMarkingReferenceImage";
import { getSavedStatus } from "../../utils/editorHelpers";
import SavedBadge from "../common/SavedBadge";

const MarkingList = (props) => {
  const {
    // params,
    field,
    type,
    title,
    labelGrup,
    headerData,
    pengecekanBerangkatData,
    pengecekanKembaliData,
    setPengecekanBerangkatDetilData,
    setPengecekanKembaliDetilData,
    pengecekanBerangkatDetilData,
    pengecekanKembaliDetilData,
    loading,
    disabled,
    onClickCamera,
    onClickAddMarking,
    onChangeKordinat,
    onClickRemove,
    onClickSave,
    onClickReload,
    listProblemData,
    folderName,
    saveDisabled,
  } = props;

  // the problem picked in the Problem list: its marker is highlighted on the Model Referensi
  const [selectedProblemId, setSelectedProblemId] = useState(null);
  // problems checked (resolved) in this session: their marker turns green
  const [resolvedProblemIds, setResolvedProblemIds] = useState({});
  const problemListRef = useRef(null);

  // pressing anywhere outside the Problem list unselects the problem (its marker is no longer highlighted)
  useEffect(() => {
    if (selectedProblemId === null) return undefined;

    const handleClickOutside = (event) => {
      if (
        problemListRef.current &&
        !problemListRef.current.contains(event.target)
      ) {
        setSelectedProblemId(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [selectedProblemId]);

  const pengecekanData =
    type === "berangkat" ? pengecekanBerangkatData : pengecekanKembaliData;

  const pengecekanDetilData =
    type === "berangkat"
      ? pengecekanBerangkatDetilData
          .filter((el) => el.label_grup === labelGrup)
          .sort((a, b) => a.urutan - b.urutan)
      : pengecekanKembaliDetilData
          .filter((el) => el.label_grup === labelGrup)
          .sort((a, b) => a.urutan - b.urutan);

  // Beri Tanda and Save need the Foto Asli first: the markings keep the url of the photo they were made on
  const hasFoto = !!(pengecekanData && pengecekanData[field]);

  const handleOnClickSave = () => {
    if (!hasFoto) return;
    if (onClickSave) {
      onClickSave(type, labelGrup, pengecekanDetilData);
    }
  };

  // saved: the photo / the markings are on the server and no marking was added or moved since. The photo is saved
  // the moment it is taken, the markings with the Save button
  const savedStatus = getSavedStatus(
    pengecekanDetilData,
    !!(pengecekanData && pengecekanData[field]) || pengecekanDetilData.length > 0
  );

  return (
    <div className="col-start-start w-full gap-3 relative">
      {/* same as the checklist table: the card is covered while it loads / refreshes */}
      {loading && (
        <div className="col-center-center absolute inset-0 z-10 rounded bg-white/60">
          <ProgressSpinner style={{ width: "2.5rem", height: "2.5rem" }} />
        </div>
      )}
      <div className="row-between-center w-full gap-2">
        <div className="row-start-center gap-3 flex-wrap">
          <span className="font-bold text-sm color text-stone-700">{title}</span>
          <SavedBadge status={savedStatus} />
        </div>
        <Button
          loading={loading}
          className="!p-0 max-h-[1.3rem] max-w-[1.3rem]"
          icon="pi pi-refresh"
          text
          rounded
          onClick={onClickReload}
        />
      </div>

      {/* block 1: the real photo - view only, this is what the Foto button writes to */}
      <div className="col-start-start gap-1 w-full">
        <div className="row-between-center w-full">
          <span className="text-xs font-semibold text-slate-400">Foto Asli</span>
          <Button
            disabled={disabled}
            className="max-h-[2rem]"
            icon="pi pi-camera"
            text
            label="Foto"
            onClick={() => onClickCamera(field)}
          />
        </div>
        {pengecekanData && pengecekanData[field] ? (
          <Image
            className="bg-white shadow-md w-full"
            src={pengecekanData[field]}
            alt={`${type}_${field}`}
            width="100%"
            preview
          />
        ) : (
          <div className="row-center-center bg-slate-100 text-slate-400 text-sm italic w-full h-[6rem] rounded">
            Belum ada foto
          </div>
        )}
      </div>

      {/* block 2: the reference model - the permanent marking surface, Beri Tanda lives here. The uploaded
      jenis_mobil master data photo (of the vehicle for gambar_*, of the trailer for gambar_box_*) is used when
      one exists, otherwise the generic outline illustration */}
      <div className="col-start-start gap-1 w-full">
        <span className="text-xs font-semibold text-slate-400">Model Referensi</span>
        <ImageCanvas
          onChangeKordinat={onChangeKordinat}
          imageUrl={getMarkingReferenceImage({ headerData, field, type })}
          markings={pengecekanDetilData}
          problemMarkings={listProblemData}
          highlightedProblemId={selectedProblemId}
          resolvedProblemIds={resolvedProblemIds}
          type={type}
          disabled={disabled}
        />
        {/* the read-only reference card (Pergi shown alongside Pulang) has nothing to add/save here */}
        {!disabled && !hasFoto && (
          <span className="text-xs font-semibold text-amber-600">
            Ambil Foto Asli dulu sebelum Beri Tanda dan Save
          </span>
        )}
        {!disabled && (
          <div className="row-between-center w-full">
            <Button
              disabled={disabled || !hasFoto}
              loading={loading}
              className="max-h-[2.5rem]"
              icon="pi pi-plus-circle"
              outlined
              label="Beri Tanda"
              onClick={() => {
                onClickAddMarking(field, type);
              }}
            />
            <Button
              loading={loading}
              disabled={disabled || saveDisabled || !hasFoto}
              className="max-h-[2.5rem]"
              icon="pi pi-save"
              label={`Save`}
              severity="success"
              onClick={handleOnClickSave}
            />
          </div>
        )}
      </div>

      {pengecekanDetilData && pengecekanDetilData.length > 0 && (
        <div className="col-start-start w-full gap-1">
          <span className="text-xs font-semibold text-slate-400">
            Tanda Baru (trip ini)
          </span>
          <div className="col-start-start w-full gap-[0.4rem]">
            {pengecekanDetilData.map((el, index) => {
              return (
                <MarkingControlButton
                  key={el.id || el._localId}
                  data={el}
                  disabled={disabled}
                  onClickRemove={onClickRemove}
                />
              );
            })}
          </div>
        </div>
      )}

      {/* block 3: checklist-style table of the old open problems of this group. Problems aren't specific to
      berangkat or kembali, so on kembali (both cards shown via "Pergi") only the editable card shows it - the
      read-only reference card would otherwise show the exact same list a second time, disabled */}
      {!disabled && listProblemData.length > 0 && (
        <div ref={problemListRef} className="col-start-start w-full gap-1">
          <span className="text-xs font-semibold text-red-500">Problem</span>
          <MarkingProblemTable
            listProblemData={listProblemData}
            disabled={disabled}
            folderName={folderName}
            selectedId={selectedProblemId}
            onResolved={(problemId) =>
              setResolvedProblemIds((prev) => ({ ...prev, [problemId]: true }))
            }
            onSelect={(problem) =>
              setSelectedProblemId((current) =>
                current === problem.id ? null : problem.id
              )
            }
          />
        </div>
      )}
    </div>
  );
};

export default MarkingList;
